<template>
    <div class="col-lg-3 col-md-4 col-sm-6">
        <!-- single-product-item start -->
        <b-card class="mt-2 product">
            <div class="sinle-product-item mb-20">
                <div class="product-thumb">
                    <div class="product-info mb-3">
                        <h5 class="mb-3">
                            <small>
                                <router-link v-if="itemType" :to="{ name: 'product', params: { itemID: ID, WarehouseID: warehouseID }/*, query: { WarehouseID: warehouseID }*/}">{{ description }}</router-link>
                                <router-link v-if="items" :to="{ name: 'composition', params: { compositionID: ID }}"> {{ description }}</router-link>
                            </small>
                        </h5>
                    </div>
                    <router-link v-if="imageUrl && itemType" :to="{ name: 'product', params: { itemID: ID, WarehouseID: warehouseID }/*, query: { WarehouseID: warehouseID }*/}">
                        <img :src="imageUrl + '&v=3'" :alt="ID" class="primary-image">
                    </router-link>
                    <router-link v-if="!imageUrl && itemType" :to="{ name: 'product', params: { itemID: ID, WarehouseID: warehouseID }/*, query: { WarehouseID: warehouseID }*/}">
                        <img src="https://placehold.it/350x350" alt="Geen afbeelding" class="primary-image">
                    </router-link>
                    <router-link v-if="items" :to="{ name: 'composition', params: { compositionID: ID }}">
                        <div class="row collage collage-default">
                            <div v-for="item in items.slice(0,4)" :key="item.ItemID" class="col-sm-6">
                                <div class="square">
                                    <img v-if="item.ImageUrl" :src="item.ImageUrl" :alt="item.ItemID">
                                </div>
                            </div>
                        </div>
                    </router-link>
                </div>
            </div>
        </b-card>
        <!-- single-product-item end -->
    </div>
</template>

<script>

export default {
    props: [
        'ID',
        'description',
        'imageUrl',
        'items',
        'warehouseID',
        'brand',
        'itemType'
    ]
}
</script>



// WEBPACK FOOTER //
// src/components/Products/Item.vue